import React from 'react';
import { I18n } from '@aws-amplify/core';
import { FormItemWrapper, LabelMediumRegular } from '@/components/Settings/DataExtraction/styles';
import { CustomInputContainer } from './styles';

export function NameFormItem(): JSX.Element {
	return (
		<FormItemWrapper
			name="name"
			label={<LabelMediumRegular>{I18n.get('Name')}</LabelMediumRegular>}
			rules={[{ required: true, message: I18n.get('Name is required') }]}
			labelCol={{ span: 24 }}
		>
			<CustomInputContainer placeholder={I18n.get('Name')} />
		</FormItemWrapper>
	);
}
